import Env from '../base/env';
import Channels from '../base/channels';
import Component from 'gia/Component';
import gsap from 'gsap';
import { ScrollTrigger } from '../vendor/gsap-bonus-umd/ScrollTrigger';
import { ScrollToPlugin } from '../vendor/gsap-bonus-umd/ScrollToPlugin';
gsap.registerPlugin(ScrollTrigger,ScrollToPlugin);

export default class Module extends Component
{
  constructor(element) {
    super(element);
    this.ref = {};
  }

  mount() {
    this.DOM = {}
    this.DOM.view = this.element
    this.DOM.anchors = this.DOM.view.parentElement.querySelectorAll('.js-anchor-page')
    this.DOM.buttons = []
    //!FX
    this.stAnchors = []
    //! VARS
    this.VARS = {}
    this.VARS.KLASS_LI = 'tw-block lg:tw-inline-block tw-mr-[30px] last:tw-mr-0 tw-mb-[15px] last:tw-mb-0 lg:tw-mb-0 tw-pointer-events-auto'
    this.VARS.KLASS_BTN = 'btn tw-font-inter-rg tw-text-sm tw-text-delort tw-text-opacity-20 lg:tw-text-opacity-100 lg:tw-text-white'
    this.VARS.IS_ANCHORING = false
    this.VARS.TOGGLED_ANCHOR = false
    this.VARS.IS_REDUCED = false

    //! FNS
    setTimeout(() => {
      this.generate()
      if(Env.mobileCSS == false) {
        this.makeSticky()
      }
      this.stickyFooterDetect()
      // Disable Pin Spacer
      this.disablePinSpacer()
      if(Env.mobileCSS) {
        this.toggle()
      }
      this.watcher()
    }, 500);

    this.fnResize = this.resize.bind(this)

    Channels.on('accordion::update',this.fnResize)
  }

  animateToggle()
  {
    if(this.VARS.TOGGLED_ANCHOR == false) {
      // const yPos = (this.VARS.IS_REDUCED)?this.toggleParams.inReduced:this.toggleParams.in;
      Env.$html.classList.add('anchorsSummary-isOpened')
      gsap.to(
        this.ref.anchorContainer,
        {
          y:this.toggleParams.in,
          ease:'quint.out',
          duration:.5,
          onStart:()=>{
            this.VARS.TOGGLED_ANCHOR = true
            this.DOM.view.classList.add('is-opened')
          }
        }
      )

    } else {
      Env.$html.classList.remove('anchorsSummary-isOpened')
      gsap.to(
        this.ref.anchorContainer,
        {
          y:this.toggleParams.out,
          ease:'quint.out',
          duration:.5,
          onStart:()=>{
            this.VARS.TOGGLED_ANCHOR = false
            this.DOM.view.classList.remove('is-opened')
          }
        }
      )

    }
  }

  disable()
  {
    this.DOM.view.classList.remove('is-reduced')
  }

  disablePinSpacer()
  {
    const parentElement = this.DOM.view.parentElement
      if(parentElement.classList.contains('pin-spacer') == true) {
        parentElement.classList.add('tw-pointer-events-none')
      }
  }

  enable()
  {
    this.DOM.view.classList.add('is-reduced')

  }

  generate()
  {
    for(let [i,anchor] of this.DOM.anchors.entries())
    {
      const li = document.createElement('li')
      li.setAttribute('class',this.VARS.KLASS_LI)
      const button = document.createElement('button')
      button.setAttribute('class',this.VARS.KLASS_BTN)
      const getTitle = anchor.getAttribute('data-title')
      button.innerHTML = getTitle
      this.ref.anchorContainer[0].appendChild(li)
      li.appendChild(button)
      button.addEventListener('click',()=>{
        if(typeof Env.smoothInstance != 'undefined') {
          Env.smoothInstance.scrollTo(`#${anchor.getAttribute('id')}`,true)
        } else {
          gsap.to(window, { scrollTo: document.getElementById(anchor.getAttribute('id')) });
          this.animateToggle()
        }

      })
      this.DOM.buttons.push(button)
      const instance = new ScrollTrigger.create({
        trigger:anchor,
        start:'top bottom',
        markers:false,
        onEnter:()=>{
          // console.log(anchor);
        },
        onToggle:()=>{
          this.resetAnchors()
          button.classList.add('is-active')
          this.ref.activeAnchor[0].innerHTML = getTitle
        }
      })
      this.stAnchors.push(instance)
    }
  }

  makeSticky()
  {
    const scrollTop = ScrollTrigger.maxScroll(document.body);
    this.sticky = ScrollTrigger.create({
      trigger:this.DOM.view,
      start:'top top',
      // end: () => ScrollTrigger.maxScroll(document.body),
      end: scrollTop,
      pin:true,
      pinSpacing:false,
    })
  }


  resetAnchors()
  {
    for(let btn of this.DOM.buttons) {
      btn.classList.remove('is-active')
    }
  }

  resize()
  {
    setTimeout(() => {
      if(typeof this.sticky != 'undefined') {
        this.sticky.kill(true)
      }
      if(typeof this.stickyFooter != 'undefined') {
        this.stickyFooter.kill(true)
      }
      if(Env.mobileCSS == false) {
        this.makeSticky()
      }
      this.stickyFooterDetect()
    }, 500);

  }

  stickyFooterDetect()
  {
    this.stickyFooter = ScrollTrigger.create({
      trigger:document.querySelector('.main-footer'),
      start:'top bottom',
      onEnter:()=>{
        if(Env.mobileCSS) {
          gsap.to(this.DOM.view , { bottom : -70, duration:.4, ease:'quint.out' })
        } else {
          gsap.to(this.DOM.view , { top : 70, duration:.4, ease:'quint.out' })
        }

      },
      onLeaveBack:()=>{
        if(Env.mobileCSS) {
          gsap.to(this.DOM.view , { bottom : 0, duration:.4, ease:'quint.out' })
        } else {
          gsap.to(this.DOM.view , { top : 0, duration:.4, ease:'quint.out' })
        }
      }
    })
  }

  toggle()
  {
    this.toggleParams = {
      inReduced:'14px',
      in:0,
      out:'130%'
    }
    gsap.set(this.ref.anchorContainer, { y:this.toggleParams.out })

    this.ref.anchorsSummaryHeader[0].addEventListener('click',()=>{
      this.animateToggle()
    })
  }

  watcher()
  {
    this.raf = requestAnimationFrame(()=>{
      let getScrollTop
      if(Env.mobileCSS) {
        getScrollTop = Env.framework.toolbox.scrollPosition().scrollY
      } else {
        getScrollTop = Env.smoothInstance.scrollTop()
      }

      const progress = getScrollTop / ScrollTrigger.maxScroll(document.body)
      if(getScrollTop > 200) {
        this.VARS.IS_REDUCED = true
        this.enable()
      } else {
        this.VARS.IS_REDUCED = false
        this.disable()
      }
      gsap.set(this.ref.progression,{ scaleX:progress ,transformOrigin:'left top' })
      this.watcher()
    })
  }


  unmount()
  {
    Channels.removeListener('accordion::update',this.fnResize)
    if(typeof this.sticky != 'undefined') {
      this.sticky.kill()
    }
    if(typeof this.stickyFooter != 'undefined') {
      this.stickyFooter.kill()
    }
    cancelAnimationFrame(this.raf)
    for(let instance of this.stAnchors) {
      instance.kill()
    }
  }
}
